<template>
  <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
    <vs-sidebar
      class="items-no-padding"
      parent="#chat-app"
      :click-not-close="clickNotClose"
      :hidden-background="clickNotClose"
      v-model="isChatSidebarActive"
      id="conn-list-sidebar"
    >
      <div class="chat__profile-search flex p-4">
        <vs-input
          icon-no-border
          icon="icon-search"
          icon-pack="feather"
          class="w-full mx-5 input-rounded-full"
          :placeholder="$t(`DATASOURCEVIEW.searchConnection`)"
          v-model="searchQuery"
        />
      </div>

      <vs-divider class="d-theme-border-grey-light m-0" />
      <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl">
        <!-- ACTIVE CHATS LIST -->

        <!-- CONTACTS LIST -->
        <div class="chat__contacts">
          <h3 class="text-primary mb-5 px-4 flex justify-between items-center">
            <span>{{$t(`DATASOURCEVIEW.connections`)}}</span>
             <feather-icon class="cursor-pointer" icon="RefreshCcwIcon" svgClasses="h-5 w-45" @click="refreshConnections"/>
            
          </h3>
          <!-- {{companiesActives}} -->
          <!-- <v-select
            v-if="isGotu"
            class="mb-5 px-4"
            :reduce="company => company.name"
            label="name"
            v-model="searchComapany"
            :clearable="false"
            :options="companiesActives"
            v-validate="'required'"
            name="cityID"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          /> -->
          <ul class="chat__contacts bordered-items">
            <li
              class="cursor-pointer"
              v-for="connection in listConnections"
              :key="connection.key"
              @click="showTables(connection.key, connection.name)"
            >
              <chat-contact :contact="connection"></chat-contact>
            </li>
          </ul>
        </div>
      </component>
    </vs-sidebar>

    <!-- RIGHT COLUMN -->
    <div
      :class="{ 'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': activeChatUser === null }"
      class="
        no-scroll-content
        chat-content-area
        border border-solid
        d-theme-border-grey-light
        border-t-0 border-r-0 border-b-0
      "
    >
      <template v-if="activeChatUser">
        <component
          :is="scrollbarTag"
          class="chat-content-scroll-area"
          style="height: 100% !important"
          :settings="settings"
          ref="chatLogPS"
          :key="$vs.rtl"
        >
          <div id="parentx-records" class="chat__log p-2" ref="chatLog">
            <div class="flex justify-start items-center">
              <feather-icon
                icon="ArrowLeftIcon"
                class="bg-white p-2 shadow-md rounded-full mr-5 lg:hidden"
                svgClasses="w-6 h-6"
                @click="toggleChatSidebar(true)"
              ></feather-icon>
              <h5 class="font-bold">
                {{ titleTable }}
              </h5>
            </div>
            <ListNameTables />
            <SidebarRecords />
          </div>
        </component>
      </template>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import ChatContact from "./ChatContact.vue";
import SidebarRecords from "./sidebarRecords.vue";
import ListNameTables from "./ListNameTables.vue";
import Api from "@/helpers/api";
import { getAllConnections } from "./connetions";

import { mapActions, mapState } from "pinia";
import { useConnStore } from "./store";
import { notify, loading, closeLoding } from "@/helpers/$vs.js";

export default {
  components: {
    VuePerfectScrollbar,
    ChatContact,
    vSelect,
    SidebarRecords,
    ListNameTables
  },
  data: () => ({
    searchComapany: "",
    connections: [],
    companies: [],
    clickNotClose: true,
    isChatSidebarActive: true,
    searchQuery: "",
    settings: {
      maxScrollbarLength: 60,
      wheelSpeed: 0.7
    },
    activeChatUser: true,
    activeSidebarRecords_: false
  }),
  mounted() {
    this.getAllConnections();
    if (this.isGotu) this.getCompanies();
  },
  methods: {
    ...mapActions(useConnStore, ["getTables"]),
    async getAllConnections() {
      const result = await getAllConnections();
      this.connections = result;
      return;
    },
    async getCompanies() {
      try {
        const result = await Api.get("/companies");
        this.companies = [{ key: 0, name: "Todos", status: "Active" }, ...result.data];
      } catch (error) {
        console.log("Error: getCompanies ", error);
      }
    },
    toggleChatSidebar(value = false) {
      this.clickNotClose = value;
      this.isChatSidebarActive = value;
    },
    async showTables(key, name) {
      const result = await this.getTables(key, name);

      if (!result) return notify(this.$t(`DATASOURCEVIEW.dataBase`), this.$t(`DATASOURCEVIEW.dataBaseNotHasTabe`), `danger`);

      if (this.windowWidth < 600) {
        this.toggleChatSidebar(false);
      }
    },
    async refreshConnections() {
      loading();
      await this.getAllConnections();
      closeLoding()
    }
  },
  computed: {
    ...mapState(useConnStore, ["titleTable", "activeSidebarRecords"]),
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    isGotu() {
      return this.$store.state.user.roleName === "GOTU";
    },
    companiesActives() {
      return this.companies.filter(company => company.status === "Active").map(({ key, name }) => ({ key, name }));
    },
    listConnections() {
      let connections = this.connections;
      if (this.isGotu) {
        connections = connections.filter(conn => conn.companyName === this.$store.state.user.companyName);
      }
      return connections
        .filter(conn => {
          if (this.searchComapany.length > 0 && this.searchComapany !== "Todos") {
            return conn.companyName.toLowerCase().includes(this.searchComapany.toLowerCase());
          }
          return true;
        })
        .filter(conn => {
          if (this.searchQuery.length > 0) {
            return conn.name.toLowerCase().includes(this.searchQuery.toLowerCase());
          }
          return true;
        });
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  beforeDestroy() {
    const store = useConnStore();
    store.$reset();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";

#chat-app {
  #conn-list-sidebar .vs-sidebar {
    max-width: 400px;
    @media only screen and (max-width: 900px) {
      max-width: 300px;
    }
    @media only screen and (max-width: 400px) {
      max-width: 400px;
    }
  }

  .sidebar-spacer--wide {
    margin-left: 400px;
    width: calc(100% - 400px);

    @media only screen and (max-width: 900px) {
      margin-left: 300px;
      width: calc(100% - 300px);
    }

    @media only screen and (max-width: 400px) {
      margin-left: 400px;
      width: calc(100% - 400px);
    }
  }
}
</style>
